import axios from 'axios'
import { BUSCAR_CIDADES_TRECHOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarCidadesTrechosPorEmpresa (codigoEmpresa) {
  const url = `${URL}/trecho/empresa/${codigoEmpresa}/cidades`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_CIDADES_TRECHOS,
        payload: response

      })
  );
}
